// extracted by mini-css-extract-plugin
export default {"content":"ox6gyUtz"};